import React from 'react';
import CrudPage from '../../components/CrudPage';
import { blogApi } from '../../services/adminApi';

const columns = [
  { header: 'ID', field: 'blogId' },
  { header: 'Title', field: 'title' },
  { header: 'Category', field: 'categoryName' },
  { header: 'Author', field: 'author' },
  { header: 'Published', field: 'isPublished', render: (v) => v ? 'Yes' : 'No' },
  { header: 'Created', field: 'createdAt', type: 'date' },
];

const formFields = [
  { name: 'title', label: 'Title', type: 'text', required: true },
  { name: 'content', label: 'Content', type: 'textarea', required: true },
  { name: 'summary', label: 'Summary', type: 'textarea' },
  { name: 'author', label: 'Author', type: 'text' },
  { name: 'categoryId', label: 'Category ID', type: 'number' },
  { name: 'imageUrl', label: 'Image URL', type: 'text' },
  { name: 'isPublished', label: 'Published', type: 'checkbox' },
];

const BlogPage = () => (
  <CrudPage
    title="Blogs"
    subtitle="Manage blog posts"
    api={blogApi}
    columns={columns}
    formFields={formFields}
    idField="blogId"
    searchField="title"
  />
);

export default BlogPage;
